export enum ColorNames {
	GHOST = 'ghost',
	TERTIARY = 'tertiary',
	SECONDARY = 'secondary',
	PRIMARY = 'primary',
	MALACHITE = 'malachite',
}
